import React from "react";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";
const DW20Over = ({ winnerScore, winnerPlayer }) => {
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="dw-over"
    >
      <motion.h2 variants={fadeVariants}>Game Over</motion.h2>
      <motion.p variants={staticBounceVariants} className="you-czar">
        We have a winner!
      </motion.p>
      <motion.p
        variants={staticBounceVariants}
        className="points"
      >{`Points: ${winnerScore.score}`}</motion.p>
      <motion.div variants={staticBounceVariants} className="single-winner">
        <div className="player-img">
          <img
            src={winnerPlayer?.profile_image}
            className="img-fluid"
            alt="user"
          />
        </div>
        <p className="name mb-0">{winnerPlayer?.display_name}</p>
      </motion.div>
    </motion.div>
  );
};

export default DW20Over;
